import type { PredictionResponse } from 'api/__GENERATED';
import { apiUtility, domainUtility } from 'utility';

import { toPrediction } from './toPrediction';

// Builds a normalized `Data.Projection` domain from a list of PredictionResponse DTOs.
// Rows with missing unitOfMeasureId are dropped silently.
function toPredictionDomain(args: { dtos: PredictionResponse[] }) {
  const { dtos } = args;

  const forecastDomain: NormalizedDomain<Data.Projection> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const projection = toPrediction(item);
      if (projection === undefined) return;
      domainUtility.mutateAdd(forecastDomain, projection);
    },
  });

  return { forecastDomain };
}

export { toPredictionDomain };
